import Alerts from '@/vdp/Alerts';
import HeroBadge from '@/vdp/HeroBadge';
import LiteGallery from '@/vdp/LiteGallery/LiteGallery';
import HeroVehicleInfo from '../HeroVehicleInfo';

export default function HeroLite() {
  return (
    <div className="relative grid bg-white l:grid-cols-[1fr_332px] l:gap-x-3xl l:p-3xl">
      <div className="grid">
        <div className="col-span-full row-span-full">
          <LiteGallery />
        </div>
        <div className="pointer-events-none z-10 col-span-full row-span-full p-8 m:p-16">
          <HeroBadge showTimer />
        </div>
      </div>
      <HeroVehicleInfo isVDPLite />
      <Alerts />
    </div>
  );
}
